<template>
<div :id="pid" class="chart"></div>
</template>

<script>
export default {
    name: 'Flot',
    props: ['points', 'total_watt', 'pid'],
    mounted() {
        this.getCurve();
    },
    methods: {
        getCurve: function () {
            const my = this;
            var start = this.setTime("04:50");
            var end = this.setTime("19:50");
            var yMax = Math.ceil(parseFloat(this.total_watt) * 1.2);

            var points = [{
                data: my.points,
                lines: {
                    show: true,
                    fill: true
                }
            }];
            var options = {
                xaxis: {
                    mode: "time",
                    timezone: "browser",
                    timeBase: "milliseconds",
                    show: false,
                    min: start,
                    max: end,
                    autoScale: 'none',
                },
                yaxis: {
                    show: false,
                    min: 0,
                    max: yMax,
                    autoScale: 'none',
                },
                grid: {
                    hoverable: false,
                    borderWidth: 0
                }
            };

            $.plot(document.getElementById(my.pid), points, options);
        },
        setTime: function (time) {
            var today = new Date();
            var day =
                today.getFullYear() +
                "/" +
                (today.getMonth() + 1) +
                "/" +
                today.getDate();
            return new Date(day + " " + time).getTime();
        },
    }
}
</script>
